import React from 'react';
import styled from 'styled-components';

const uniqueId = (() => {
  let counter = 0;
  return () => `gradient-icon-${++counter}`;
})();

// lucide ikonlarının tamamı bu viewBox'ı kullanır (defaultAttributes.js). Gradyan
// `userSpaceOnUse` olduğu için koordinatlar BU uzayda verilir — piksel boyutunda değil.
const LUCIDE_VIEWBOX = 24;

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;

  svg {
    stroke: ${({ $url }) => $url};
    fill: none;
  }
`;

/**
 * Marka gradyanıyla boyanmış ikon.
 *
 * ═══════════ NEDEN userSpaceOnUse (objectBoundingBox DEĞİL) ═══════════
 * Gradyan eskiden varsayılan `objectBoundingBox` birimlerini kullanıyordu ve bu, ikonların
 * bir kısmını GÖRÜNMEZ yapıyordu. SVG spesifikasyonu: bir elemanın sınırlayıcı kutusunun
 * genişliği ya da yüksekliği SIFIRSA, objectBoundingBox gradyanı uygulanamaz ve eleman
 * HİÇ BOYANMAZ.
 *
 * lucide ikonlarının çoğu tam da böyle path'ler içerir — `BarChart3`'ün çubukları
 * (`M18 17V9`, `M13 17V5`, `M8 17v-3`) düz DİKEY çizgilerdir, yani kutuları sıfır
 * genişliktedir. Sonuç: çubuklar kayboluyor, yalnız `M3 3v18h18` (eksenler) çiziliyordu —
 * ikon "sadece x ve y ekseni" gibi görünüyordu. Aynı hata her yatay/dikey çizgi taşıyan
 * ikonu (Link2, Clock akrepleri, Target çizgileri…) sessizce bozuyordu.
 *
 * `userSpaceOnUse` gradyanı elemanın kutusuna DEĞİL, ikonun kendi koordinat uzayına
 * bağlar; sıfır boyutlu path'ler de doğru boyanır.
 *
 * Sol menüde bu yalnız PASİF durumda görünürdü: seviye-0 aktif öğede ikon düz beyaz
 * çizilir (dolu mavi zemin üstünde gradyan kaybolur), yani hata "menü seçili değilken
 * ikon bozuk" biçiminde ortaya çıkıyordu.
 */
export default function GradientIcon({
  icon: Icon,
  size = 20,
  from,
  to,
  angle = 120,
  style,
  className,
}) {
  const id = React.useMemo(() => uniqueId(), []);
  const defaultFrom = from || '#0291EF';
  const defaultTo = to || '#02D3BF';

  // Açıyı viewBox uzayında bir doğru parçasına çeviriyoruz (merkezden iki yöne yarım köşegen).
  const rad = (angle * Math.PI) / 180;
  const half = LUCIDE_VIEWBOX / 2;
  const x1 = (half - Math.cos(rad) * half).toFixed(2);
  const y1 = (half - Math.sin(rad) * half).toFixed(2);
  const x2 = (half + Math.cos(rad) * half).toFixed(2);
  const y2 = (half + Math.sin(rad) * half).toFixed(2);

  return (
    <Wrapper $url={`url(#${id})`} style={style} className={className}>
      <svg width={0} height={0} style={{ position: 'absolute' }} aria-hidden="true">
        <defs>
          <linearGradient id={id} gradientUnits="userSpaceOnUse" x1={x1} y1={y1} x2={x2} y2={y2}>
            <stop offset="0%" stopColor={defaultFrom} />
            <stop offset="100%" stopColor={defaultTo} />
          </linearGradient>
        </defs>
      </svg>
      <Icon size={size} />
    </Wrapper>
  );
}
